import script from "./CompletedAchievementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletedAchievementModal.vue?vue&type=script&setup=true&lang=ts"

import "./CompletedAchievementModal.vue?vue&type=style&index=0&id=aa678bd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa678bd2"]])

export default __exports__